import type { WeeklyActionChannel } from "./weeklyActions";

export type WeeklyActionChannelPresentation = {
    label: string;
    description: string;
    icon: string;
    iconClass: string;
};

export type WeeklyActionModePresentation = {
    label: "On your own" | "With Nadia" | "Role play with Nadia";
    icon: string;
    theme: "work" | "nadia";
};

export type WeeklyActionTaxonomyPresentation = {
    label: "Learning resource" | "Role play with Nadia" | "With Nadia" | "In a meeting" | "In your work" | "Weekly reminder";
    icon: string;
    kind: "resource" | "tag";
    theme: "work" | "nadia";
};

const channelPresentations: Record<WeeklyActionChannel, WeeklyActionChannelPresentation> = {
    learning_material: {
        label: "Learning resource",
        description: "A short resource selected to help you prepare for a real opportunity at work.",
        icon: "bi-book",
        iconClass: "bg-chip-neutral-bg text-chip-neutral-text",
    },
    role_play_with_nadia: {
        label: "Practise with Nadia",
        description: "Rehearse a real conversation with Nadia in a lower-stakes setting first.",
        icon: "bi-person-video2",
        iconClass: "bg-chip-neutral-bg text-chip-neutral-text",
    },
    conversation_with_nadia: {
        label: "Work with Nadia",
        description: "Use Nadia's coaching support to think through, learn, or create something useful.",
        icon: "bi-chat-square-text",
        iconClass: "bg-chip-neutral-bg text-chip-neutral-text",
    },
    flow_of_work_meeting: {
        label: "In a meeting",
        description: "Try this in a real conversation or calendar event already in your work.",
        icon: "bi-people",
        iconClass: "bg-chip-neutral-bg text-chip-neutral-text",
    },
    flow_of_work_activity: {
        label: "In your work",
        description: "Put this into practice in your day-to-day work outside a meeting.",
        icon: "bi-briefcase",
        iconClass: "bg-chip-neutral-bg text-chip-neutral-text",
    },
    action_review_reminder: {
        label: "Weekly reminder",
        description: "Set aside time to reflect on your actions and choose what to focus on next.",
        icon: "bi-bell",
        iconClass: "bg-chip-neutral-bg text-chip-neutral-text",
    },
};

const actionModePresentations: Record<WeeklyActionChannel, WeeklyActionModePresentation> = {
    learning_material: {
        label: "On your own",
        icon: "bi-pencil",
        theme: "work",
    },
    role_play_with_nadia: {
        label: "Role play with Nadia",
        icon: "bi-chat",
        theme: "nadia",
    },
    conversation_with_nadia: {
        label: "With Nadia",
        icon: "bi-chat",
        theme: "nadia",
    },
    flow_of_work_meeting: {
        label: "On your own",
        icon: "bi-pencil",
        theme: "work",
    },
    flow_of_work_activity: {
        label: "On your own",
        icon: "bi-pencil",
        theme: "work",
    },
    action_review_reminder: {
        label: "On your own",
        icon: "bi-pencil",
        theme: "work",
    },
};

const actionTaxonomyPresentations: Record<WeeklyActionChannel, WeeklyActionTaxonomyPresentation> = {
    learning_material: {
        label: "Learning resource",
        icon: "bi-file-richtext",
        kind: "resource",
        theme: "work",
    },
    role_play_with_nadia: {
        label: "Role play with Nadia",
        icon: "bi-people",
        kind: "tag",
        theme: "nadia",
    },
    conversation_with_nadia: {
        label: "With Nadia",
        icon: "bi-chat-left",
        kind: "tag",
        theme: "nadia",
    },
    flow_of_work_meeting: {
        label: "In a meeting",
        icon: "bi-calendar",
        kind: "tag",
        theme: "work",
    },
    flow_of_work_activity: {
        label: "In your work",
        icon: "bi-pencil",
        kind: "tag",
        theme: "work",
    },
    action_review_reminder: {
        label: "Weekly reminder",
        icon: "bi-bell",
        kind: "tag",
        theme: "work",
    },
};

export const getWeeklyActionChannelPresentation = (channel: WeeklyActionChannel): WeeklyActionChannelPresentation => channelPresentations[channel];
export const getWeeklyActionModePresentation = (channel: WeeklyActionChannel): WeeklyActionModePresentation => actionModePresentations[channel];
export const getWeeklyActionTaxonomyPresentation = (channel: WeeklyActionChannel): WeeklyActionTaxonomyPresentation => actionTaxonomyPresentations[channel];
